module.exports = __webpack_public_path__ + "img/horizontal_4_5_8023.06985cd5.png";